// Unit conversion function for thickness and pipe diameter
export const convertLengthValue = (value, fromUnit, toUnit) => {
  if (!value || !fromUnit || !toUnit || fromUnit === toUnit) return value;

  const numValue = parseFloat(value);
  if (isNaN(numValue)) return value;

  // Convert to inches first, then to target unit
  let valueInInches = numValue;

  // Convert from source unit to inches
  switch (fromUnit.toLowerCase()) {
    case 'cm':
      valueInInches = numValue / 2.54;
      break;
    case 'mm':
      valueInInches = numValue / 25.4;
      break;
    case 'in':
      valueInInches = numValue;
      break;
    default:
      return value;
  }

  // Convert from inches to target unit
  switch (toUnit.toLowerCase()) {
    case 'cm':
      return (valueInInches * 2.54).toFixed(2);
    case 'mm':
      return (valueInInches * 25.4).toFixed(2);
    case 'in':
      return valueInInches.toFixed(2);
    default:
      return value;
  }
};
